import React, { useEffect, useState } from 'react';

import { Divider, Card, Row, Col, Switch } from 'antd';
import DF from 'DisplayFramework';

import { Form } from 'antd';
import { useForm } from 'antd/lib/form/Form';

import Button from 'components/Button';
import Title from 'components/Title';
import FormInput from 'components/FormInput';
// import InputFilePayment from './InputFilePayment';
import { getMgParValueByParCode } from 'services/parametersService';
import Value from 'components/Value';
import { importpaymentfile } from 'services/PaymentServices';
import JobResult from 'pages/Accounting/Components/JobResult';
import { useQuery } from 'react-query';
import InputFilePayment from './InputFilePayment';
import ParListSelect from 'components/ParListSelect';
import UtinaCard from 'components/UtinaCard';

const PFileIMPORT = () => {
  const [extractionModel, setextractionModel] = useState<string>();
  const loadExtractModel = async () => {
    await getMgParValueByParCode({
      parcode: 'PIEXTMODEL',
    })
      .then((response) => {
        if (response.data != null) {
          setextractionModel(response.data.parvaluemin);
          form.setFieldsValue({
            extractionModel: response.data.parvaluemin ?? 'UNDEFINED',
          });
        }
      })
      .catch((err) => {});
  };

  useEffect(() => {
    loadExtractModel();
  });

  const [form] = useForm();

  const [searchParams, setSearchParams] = useState({
    extractionMode: extractionModel ?? 'SIMT',
    filename: form.getFieldValue('filename'),
    flagCreatePaymentIfNotExist: false,
    payfileorigin: '',
  });

  const {
    data: jobResponse,
    refetch,
    isFetching,
  } = useQuery(
    ['importpaymentfile', searchParams],
    () =>
      importpaymentfile(searchParams).then((res) => {
        return res;
      }),
    {
      enabled: false,
    }
  );

  const onFinish = (values: any) => {
    setSearchParams({
      ...searchParams,
      filename: values.filename,
      extractionMode: values.extractionModel,
      ...values,
    });
    setTimeout(refetch, 0);
  };

  return (
    <DF.Provider pagcode="pfileimport">
      <Card
        title={<Title level={4} comcode="pfileimport"></Title>}
        size="small"
      >
        <Form form={form} onFinish={onFinish} layout="vertical">
          <Row>
            <Col md={19}>
              <Row gutter={10}>
                <Col md={15}>
                  <UtinaCard comcode="popoulationtotreat" level={5}>
                    <Row gutter={10}>
                      <FormInput col lg={8} name="filename">
                        <InputFilePayment />
                      </FormInput>

                      <FormInput col lg={8} name="payfileorigin">
                        <ParListSelect parcode="PAYFORIGIN" />
                      </FormInput>

                      <FormInput col lg={8} name="extractionModel">
                        <Value />
                      </FormInput>
                    </Row>
                  </UtinaCard>
                </Col>
                <UtinaCard
                  style={{
                    height: '100% !important',
                    border: '1px solid rgb(192, 234, 230) !important',
                  }}
                  comcode="flagsautonetting"
                  level={5}
                  lg={6}
                >
                  <Row align="middle">
                    <FormInput
                      col
                      lg={24}
                      wrapperCol={{ span: 16 }}
                      name="flagCreatePaymentIfNotExist"
                    >
                      <Switch />
                    </FormInput>
                  </Row>
                </UtinaCard>
              </Row>
            </Col>

            <Col
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <Button
                loading={isFetching}
                comcode="runservice"
                type="primary"
                htmlType="submit"
                style={{ width: 200, height: 60 }}
              />
            </Col>
          </Row>

          <Row>
            <Col style={{ alignContent: 'center' }} xs={24}>
              {isFetching && (
                <Title level={3} type="danger" comcode="pleasewait" />
              )}
            </Col>
          </Row>
        </Form>
        <Divider></Divider>
        <br />
        <br />
        <UtinaCard comcode="result" level={5}>
          <JobResult
            jobResponse={jobResponse}
            entity="PAYMENT"
            mode="PAYMENT"
            filetype="INPUT"
          />
        </UtinaCard>
      </Card>
    </DF.Provider>
  );
};

export default PFileIMPORT;
